import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../packages/JsonQuery';

export const trackErrorModalOpen = (sc: TJsonQuery) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Show',
    label: 'BrokerDealPopUpFail',
    sc,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
};
